<template>
  <div id="app">
    <transition name="routerView1">
      <router-view v-if="isRouterAlive"></router-view>
    </transition>
    <audio id="music" loop></audio> 
    <audio id="commentary"></audio>
    <transition>
      <div class="vtour" id="elVtour">
        <vtour></vtour>
      </div>
    </transition>
  </div>
</template>

<script>
import vtour from "@/components/vtour.vue";
export default {
    provide(){
        return {
            reload: this.reload
        }
    },
    data() {
        return {
            isRouterAlive: true,
        }
    },
    methods: {
        reload(){
            this.isRouterAlive = false;
            this.$nextTick(() => {
                this.isRouterAlive = true;
            });
        },
    },
	components: {
		vtour
	},
	computed: {
		vtourArr() {
			return this.$store.state.vtourArr;
		},
		musicState() {
			return this.$store.state.musicState;
		},
		soundState(){
			return this.$store.state.soundState;
		},
	},
	watch: {
		vtourArr(newValue) {
			// console.log(newValue);
			this.appState = 1;
			const music = document.getElementById("music");
			music.src = "https://hmltec.oss-cn-beijing.aliyuncs.com/jinpai/backgroundmusic.mp3";
			music.play();
		},
		musicState(newValue, oldValue) {
			console.log("音乐播放状态改变了，新的状态是", newValue);
			const music = document.getElementById("music");
			if (parseInt(newValue)) {
				music.play();
			} else {
				music.pause();
			}
		},
		soundState(newValue, oldValue) {
			const commentary = document.getElementById("commentary");
			if(parseInt(newValue)){
				commentary.play();
			}else{
				commentary.pause();
			}
		},
	}
};
</script>

<style lang="scss">
// 元素从显示到隐藏
.routerView1-enter,
.routerView1-leave-to {
  opacity: 0;
}
// 控制元素显示过程中实现的具体动画效果
.routerView1-enter-active,
.routerView1-leave-active {
  transition: all 0.3s ease;
}
// 控制元素完全显示之后的状态(样式、位移信息)
.routerView1-enter-to,
.routerView1-leave {
  opacity: 1;
}
.vtour {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  transition: all 0.3s ease;
}
</style>
